import { ActivityEntityName, EntityQueueFieldSource, EntityViewDisplay, EntityViewSortDirection } from '@jms/model';
import { toQueueFieldOptions } from '../../queue.field.options';
import { createEntityAdapter } from './entity.step.adapter';
import { financeQueueColumnFields } from './finance.queue.columns';
import { QueueAdapterDeps, QueueStepAdapter } from './queue.step.adapter';

const column = (path: string, name: string) => ({ ref: { source: EntityQueueFieldSource.Entity, path }, name, visible: true });

// Invoices and bills share a document shape, so their queues start from the same columns: the ones BGIS's error
// queue calls for (CLA-026), newest sync attempt first
function createEntityFinanceAdapter(deps: QueueAdapterDeps, entity: ActivityEntityName.Invoice | ActivityEntityName.Bill, labels: { entity: string; number: string; contact: string; date: string }): QueueStepAdapter {

  return createEntityAdapter(deps, {
    entity,
    entityLabel: labels.entity,
    resolveColumnOptions: map => {

      const meta = map[entity];
      return meta ? toQueueFieldOptions(financeQueueColumnFields(meta), 'entity', meta.displayName ?? labels.entity, true) : [];
    },
    defaultTable: () => ({
      display: EntityViewDisplay.Table,
      fixed: [],
      other: [
        column('entity.invoiceNumber', labels.number),
        column('entity.type', 'Type'),
        column('entity.contact', labels.contact),
        column('entity.invoiceDate', labels.date),
        column('entity.total', 'Total'),
        column('entity.status', 'Status'),
        column('entity.integration.status', 'Sync Status'),
        column('entity.integration.date', 'Last Sync Attempt'),
        column('entity.integration.error', 'Sync Error'),
      ],
      sortBy: { source: EntityQueueFieldSource.Entity, path: 'entity.integration.date' },
      sortOrder: EntityViewSortDirection.Desc,
    }),
  });
}

export const createEntityInvoiceAdapter = (deps: QueueAdapterDeps): QueueStepAdapter =>
  createEntityFinanceAdapter(deps, ActivityEntityName.Invoice, { entity: 'Invoice', number: 'Invoice Number', contact: 'Customer', date: 'Invoice Date' });

export const createEntityBillAdapter = (deps: QueueAdapterDeps): QueueStepAdapter =>
  createEntityFinanceAdapter(deps, ActivityEntityName.Bill, { entity: 'Bill', number: 'Bill Number', contact: 'Account', date: 'Bill Date' });
